import React from 'react';
import { Modal, Input, Form, Select } from 'antd';

import { RUC, DNI } from '../../../common/types/tipoDocumentoType';
import { FORMAT_NUMBER } from '../../../common/types/regularExpresionType';

const { Option } = Select;
const { Search } = Input;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleChangeTipoDocumento = (option) => {
        this.props.form.setFieldsValue({
            flagRuc: option.key === RUC.ID ? true : false,
            numeroDocumento: '',
            nombre: '',
            razonSocial: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            idCondicionSunat: undefined,
            idEstadoContribuyente: undefined,
            idDepartamento: undefined,
            idProvincia: undefined,
            idUbigeo: undefined,
            direccion: '',
        }, () => {
            this.props.form.validateFields(["numeroDocumento"]);
            this.props.onChange("clear");
        });
    }

    numeroDocumentoCustomValidation = (rule, value, callback) => {
        var idTipoDocumento = this.props.form.getFieldValue('idTipoDocumento')?.key;
        if (idTipoDocumento !== undefined) {
            var numeroDocumentoLongitud = this.props.form.getFieldValue('numeroDocumento').length;
            var longitud = idTipoDocumento === RUC.ID ? 11 : 8;

            if ([RUC.ID, DNI.ID].includes(idTipoDocumento)) {
                var regexp = new RegExp(FORMAT_NUMBER);
                if (!regexp.test(value))
                    callback(`Formato ${idTipoDocumento === RUC.ID ? 'RUC' : 'DNI'} invalido.`);
                else if (numeroDocumentoLongitud !== longitud && numeroDocumentoLongitud > 0)
                    callback('La longitud de ser de ' + longitud + ' caracteres.');
            }
        }
        callback();
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    idTipoDocumento: values.idTipoDocumento.key,
                    numeroDocumento: values.numeroDocumento,
                    razonSocial: values.razonSocial,
                    nombre: values.nombre,
                    apellidoPaterno: values.apellidoPaterno,
                    apellidoMaterno: values.apellidoMaterno,
                    idCondicionSunat: values.idCondicionSunat.key,
                    idEstadoContribuyente: values.idEstadoContribuyente.key,
                    idUbigeo: values.idUbigeo.key,
                    direccion: values.direccion,
                    mtc: values.mtc
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('flagRuc', { initialValue: this.props.formValues.flagRuc });

        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Transporte" : "Modificar Transporte"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="800px"
            >
                <Form>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Tipo de Documento">
                                {getFieldDecorator('idTipoDocumento', {
                                    initialValue: this.props.formValues.idTipoDocumento ?
                                        { key: this.props.formValues.idTipoDocumento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.'
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione tipo de documento"}
                                        optionFilterProp="children"
                                        onChange={this.handleChangeTipoDocumento}
                                    >
                                        {this.props.formValues.tiposDocumento.map(item => (
                                            <Option key={item.id} value={item.id}>{item.abreviatura}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Número Documento">
                                {getFieldDecorator('numeroDocumento', {
                                    initialValue: this.props.formValues.numeroDocumento,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Campo obligatorio.',
                                            whitespace: true
                                        },
                                        {
                                            validator: this.numeroDocumentoCustomValidation
                                        }
                                    ]
                                })(
                                    <Search
                                        placeholder="Búsqueda por Documento"
                                        autoComplete="off"
                                        maxLength={50}
                                        loading={this.props.formValues.searchLoading}
                                        onSearch={value => this.props.onBuscarPadronReducido(this.props.form.getFieldValue('idTipoDocumento').key, value, this.props.form)}
                                    />
                                )}
                            </Form.Item>
                        </div>

                    </div>
                    <div className="row" style={{ display: this.props.form.getFieldValue('flagRuc') ? "" : "none" }}>
                        <div className="col-md-12 form-group">
                            <Form.Item label="Razón Social">
                                {getFieldDecorator('razonSocial', {
                                    initialValue: this.props.formValues.razonSocial,
                                    rules: [{
                                        required: this.props.form.getFieldValue('flagRuc'),
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Razón Social"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row" style={{ display: !this.props.form.getFieldValue('flagRuc') ? "" : "none" }}>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Apellido Paterno">
                                {getFieldDecorator('apellidoPaterno', {
                                    initialValue: this.props.formValues.apellidoPaterno,
                                    rules: [{
                                        required: !this.props.form.getFieldValue('flagRuc'),
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Apellido Paterno"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Apellido Materno">
                                {getFieldDecorator('apellidoMaterno', {
                                    initialValue: this.props.formValues.apellidoMaterno,
                                    rules: [{
                                        required: !this.props.form.getFieldValue('flagRuc'),
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Apellido Materno"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row" style={{ display: !this.props.form.getFieldValue('flagRuc') ? "" : "none" }}>
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: !this.props.form.getFieldValue('flagRuc'),
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Condición Sunat">
                                {getFieldDecorator('idCondicionSunat', {
                                    initialValue: this.props.formValues.idCondicionSunat ?
                                        { key: this.props.formValues.idCondicionSunat } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Condición Sunat"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.condicionesSunat.map(item => (

                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Estado Contribuyente">
                                {getFieldDecorator('idEstadoContribuyente', {
                                    initialValue: this.props.formValues.idEstadoContribuyente ?
                                        { key: this.props.formValues.idEstadoContribuyente } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Estado Contribuyente"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.estadosContribuyente.map(item => (

                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-6 form-group">
                            <Form.Item label="Número de registro del MTC">
                                {getFieldDecorator('mtc', {
                                    initialValue: this.props.formValues.mtc,
                                    rules: [{
                                        required: false,
                                    }]
                                })(
                                    <Input
                                        placeholder="Número de registro del MTC"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Departamento">
                                {getFieldDecorator('idDepartamento', {
                                    initialValue: this.props.formValues.idDepartamento ?
                                        { key: this.props.formValues.idDepartamento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione departamento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idProvincia: undefined });
                                            this.props.form.setFieldsValue({ idUbigeo: undefined });
                                            this.props.onChange("idDepartamento", option.key)
                                        }}
                                    >
                                        {this.props.formValues.departamentos.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Provincia">
                                {getFieldDecorator('idProvincia', {
                                    initialValue: this.props.formValues.idProvincia ?
                                        { key: this.props.formValues.idProvincia } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione provincia"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idUbigeo: undefined });
                                            this.props.onChange("idProvincia", option.key)
                                        }}
                                    >
                                        {this.props.formValues.provincias.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Distrito">
                                {getFieldDecorator('idUbigeo', {
                                    initialValue: this.props.formValues.idUbigeo ?
                                        { key: this.props.formValues.idUbigeo } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione distrito"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.distritos.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Dirección">
                                {getFieldDecorator('direccion', {
                                    initialValue: this.props.formValues.direccion,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.'
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Dirección"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)